import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Feedback
 *
 */

const Feedback = lazyLoad(
  () => import('app/modules/Feedback'),
  (module) => module.default,
);

export default Feedback;
